import React from "react";

const ServiceFeesPolicy = () => {
  return (
    <>
      <p><strong>What are Teache service fees?</strong></p>
      <p>To help Teache run smoothly&nbsp;and to cover the costs of the products and services we provide, we charge a service fee when a booking is confirmed.</p>
      <p><strong>Fees for Teache Classes</strong></p>
      <p><strong>Instructor service fee</strong></p>
      <p>We charge Instructors who offer classes a 20% service fee. The service fee is automatically deducted from the Instructor&rsquo;s payout. We waive this fee for certain social impact classes.</p>
      <p><strong>User service fee</strong></p>
      <p>We currently do not charge a User service fee to Users. Teache reserves the right to change the service fees for Users at any time and will notify Users of any fee changes before they become effective. Fee changes will not affect bookings made before the effective date of the fee change.</p>
      <p><strong>Geographic Restrictions</strong></p>
      <p>The owner of the Platform is based in the State of New York in the United States. We make no claims that the Platform or any of its content is accessible or appropriate outside of the United States, including taxes outside of the United States. Instructor Fees through the Teache Platform may not be legal for certain Users or in certain countries. If you access the Platform and provide services to a User outside the United States, you do so on your own initiative. You are responsible for tax compliance with local laws outside the United States.</p>
    </>
  );
};

export default ServiceFeesPolicy;
